import React from 'react';
import { Field } from 'formik';
import { v4 as uuid } from 'uuid';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import tabletIcon from 'assets/images/tablet2.png';
import 'react-lazy-load-image-component/src/effects/opacity.css';

const CheckboxGroup = (props) => {
  const { label, gif, name, options, isRequired, handleNext, ...rest } = { ...props };
  const { control } = { ...rest };
  const isSelectImage = control === 'select-image';
  const mapOptions = options.map((item) => {
    if (item.value) {
      return item;
    }
    return { value: item, label: item };
  });

  return (
    <div className="question">
      {isSelectImage ? (
        <>
          <div className="question__validation">
            <div className="question__checkbox">
              <img 
                src={tabletIcon}
                alt="tablet icon"
              />
            </div>
            <label htmlFor={name}>{label}</label>
          </div>
          <div className="question__imagepicker-container">
            <Field id={name} name={name} {...rest}>
              {({ field }) =>
                (gif || []).map((imageUrl, index) => {
                  const value = index.toString();
                  return (
                    <label
                      key={value}
                      className={`radio radio--${Array.isArray(field.value) && field.value.includes(value) ? 'checked' : ''} question__imagepicker__wrapper`}
                    >
                      <div className="question__imagepicker-content">
                        <div className="question__imagepicker-number">
                          <span>{index + 1}</span>
                        </div>
                        <div className="question__imagepicker-image">
                          <LazyLoadImage
                            src={imageUrl}
                            alt={`Opción ${index + 1}`}
                            effect="opacity"
                          />
                        </div>
                      </div>
                      <input
                        type="checkbox"
                        id={`option-${index}`}
                        {...field}
                        value={value}
                        checked={Array.isArray(field.value) && field.value.includes(value)}
                      />
                      <span className="checkmark-box" />
                    </label>
                  );
                })
              }
            </Field>
          </div>
        </>
      ) : (
        <>
          <div className="question__validation">
            <div className="question__checkbox">
              <img 
                src={tabletIcon}
                alt="tablet icon"
              />
            </div>
            <label htmlFor={name}>{label}</label>
          </div>
          {!!gif && (
            <div className="question__gif">
              <LazyLoadImage effect="opacity" src={gif} alt="this is a Gif" />
            </div>
          )}
          <div className="question__multiple-options">
            <Field id={name} name={name} {...rest}>
              {({ field }) => (
                <>
                  {mapOptions.map((option) => (
                    <label key={option.value} className={`radio radio--${field.value.includes(option.value) && 'checked'}`}>
                      {option.label}
                      <input
                        type="checkbox"
                        id={option.value}
                        {...field}
                        value={option.value}
                        checked={field.value.includes(option.value)}
                      />
                      <span className="checkmark-box" />
                    </label>
                  ))}
                </>
              )}
            </Field>
          </div>
        </>
      )}
    </div>
  );
};


export default CheckboxGroup;
